var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowOrganizations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 243.149,
    height: 243.149,
    rx: 20,
    fill: "#B39FDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 101.833C132.976 101.833 131.333 100.191 131.333 98.1666V92.6666H116.666V98.1666C116.666 100.191 115.024 101.833 113 101.833C110.976 101.833 109.333 100.191 109.333 98.1666V92.6666C109.333 88.6223 112.622 85.3333 116.666 85.3333H131.333C135.377 85.3333 138.666 88.6223 138.666 92.6666V98.1666C138.666 100.191 137.024 101.833 135 101.833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.603 134.389C125.943 134.646 124.99 134.829 124 134.829C123.01 134.829 122.057 134.646 121.177 134.316L80 120.603V148.58C80 154.153 84.51 158.663 90.0833 158.663H157.917C163.49 158.663 168 154.153 168 148.58V120.603L126.603 134.389Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 106.417V114.813L124.88 129.187C124.587 129.297 124.293 129.333 124 129.333C123.707 129.333 123.413 129.297 123.12 129.187L80 114.813V106.417C80 100.843 84.51 96.3333 90.0833 96.3333H157.917C163.49 96.3333 168 100.843 168 106.417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowOrganizations);
export default __webpack_public_path__ + "static/media/icon-flow-organizations.658632a959d46168ba21e3d4c9880639.svg";
export { ForwardRef as ReactComponent };